<template>
  <div>
    <div v-if="applicationData && questionData && categorizationsData && userData" style="padding: 1rem;">
      <dialog id="purchase-modal">
        <svg @click="closeModal('purchase-modal');" class="close-x" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg>
        <div class="purchase-modal-content">
          <div v-if="applicationData.is_free" id="free-container">
            <div class="layout-left">
              <h4>Review Order</h4>
              <p>
                This is App is Free
              </p>
            </div>
            <div class="layout-right">
              <h4>Order Summary</h4>
              <div class="total-price">
                <div>Total</div>
                <span>{{ applicationData.currency_code }} 0.00</span>
              </div>
              <button class="black-button-pill-global" @click="testingPayment">Checkout</button>
            </div>
          </div>
          <div v-else id="cost-container">
            <div id="payment-info-container" class="layout-left">
              <h4>Payment Method</h4>
              <div :class="['payment-method-card', paymentMethod == 'credit' ? 'selected-payment-method' : null]" @click="paymentMethod = 'credit'">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M512 80c8.8 0 16 7.2 16 16l0 32L48 128l0-32c0-8.8 7.2-16 16-16l448 0zm16 144l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"/></svg>
                <div>Credit Card</div>
              </div>
              <div :class="['payment-method-card', paymentMethod == 'payPal' ? 'selected-payment-method' : null]" @click="paymentMethod = 'payPal'">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4 .7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9 .7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"/></svg>
                <div>Pay Pal</div>
              </div>
              <div v-if="paymentMethod == 'credit'" id="payment-info">
                <div>
                  <div>Cardholder First Name</div>
                  <input type="text" />
                </div>
                <div>
                  <div>Cardholder Last Name</div>
                  <input type="text" />
                </div>
                <div class="span2Col">
                  <div>Card Number</div>
                  <input type="text"/>
                </div>
                <div>
                  <div>Expiration Date</div>
                  <div>
                    <select style="margin-right: 5px;">
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </select>
                    <select>
                      <option v-for="year in expirationYears" :key="year" :value="year">
                        {{ year }}
                      </option>
                    </select>
                  </div>
                </div>
                <div>
                  <div>Security Code</div>
                  <input type="text" maxlength="4" style="width: 4rem;" />
                </div>
                <h4 style="margin-top: 1rem;" class="span2Col">Billing Information</h4>
                <div>
                  <div>Billing Address</div>
                  <input type="text" />
                </div>
                <div>
                  <div>City</div>
                  <input type="text" />
                </div>
                <div>
                  <div> State/Province/Region</div>
                  <input type="text" />
                </div>
                <div>
                  <div>Postal Code / ZIP Code</div>
                  <input type="text" />
                </div>
                <div>
                  <div>Country</div>
                  <input type="text" />
                </div>
                <div>
                  <div>Phone Number</div>
                  <input type="tel" />
                </div>
              </div>
              <div v-else-if="paymentMethod == 'payPal'" id="payPal-info">
                <div>PayPal transactions are processed securely on the PayPal website. Click the button below to open a new browser window and start the payment process. You’ll have the opportunity to review your order before completing the purchase.</div>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5 .5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3 .5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5 .1-9.8-6.9-15.5-16.2-15.5z"/></svg>
              </div>
            </div>
            <div id="plan-info-checkout-container" class="layout-right">
              <h4>Pricing Plan</h4>
              <div v-if="applicationData.single_unit_pricing" id="unit-plan-container" @click="paymentPlan = 'unit'">
                <input type="radio" v-model="paymentPlan" name="payment-plan-checkout" value="unit" />
                <div>
                  <div>Pay By Unit</div>
                  <small>Select Quantity</small>
                  <div class="custom-quantity-input">
                    <button @click="customQuantityChooser('decrement')">-</button>
                    <span class="custom-quantity-input-number">{{ this.paymentInputObject.numberOfUnits }}</span>
                    <button @click="customQuantityChooser('increment')">+</button>
                  </div>
                </div>
              </div>
              <div v-if="applicationData.monthly_subscription_pricing" id="monthly-plan-container" @click="paymentPlan = 'monthly'">
                <input type="radio" v-model="paymentPlan" name="payment-plan-checkout" value="monthly" />
                <div>
                  <div>Pay By Month</div>
                  <small>{{ applicationData.currency_code }} {{ applicationData.monthly_subscription_pricing }}/Month</small>
                </div>
              </div>
              <div class="total-price">
                <div>Total</div>
                <span v-if="paymentPlan == 'monthly'">
                  <span>{{ applicationData.currency_code }} {{ applicationData.monthly_subscription_pricing }} / Month</span>
                </span>
                <span v-else-if="paymentPlan == 'unit'">
                  <span>{{ applicationData.currency_code }} {{ totalPrice }} / Unit</span>
                </span>
              </div>
              <button class="black-button-pill-global" @click="testingPayment" style="color: red; font-weight: 700;">TESTING PURPOSES TO SKIP PAYMENT (REMOVE LATER)</button>
            </div>
          </div>
        </div>
      </dialog>
      <dialog id="receipt-modal">
        <h2>Thank You!</h2>
        <div>
          You will be able to see your application in your activities page.
          <div style="display: flex; justify-content: flex-end; margin-top: 1rem;">
            <button class="grey-button-pill-global" style="margin-right: 5px;" @click="closeModal('receipt-modal');">Return to Marketplace</button>
            <button class="black-button-pill-global" @click="goToActivities">Go to Activities</button>
          </div>
        </div>
      </dialog>
      <div id="dynamic-page-grid">
        <div>
          <img v-if="applicationData.image != ''" :src="`${reverseProxy}/api/${applicationData.image}`" alt="Picture N/A" loading="lazy" />
          <img v-else :src="getURLImage(applicationData.image)" />
          <div id="preview-button">
            <button>
              <router-link :to="`/appTester/${applicationID}`">
                Preview
              </router-link>
            </button>
          </div>
          <div id="application-base-info">
            <div>Owner: {{ `${userData.name} (${userData.email}) ` }}</div>
            <div>App ID: {{ applicationData.application_id }}</div>
            <div>Published: {{ formatDate(applicationData.published_date) }}</div>
          </div>
        </div>
        <div>
          <h1>{{ applicationData.title }}</h1>
          <div v-if="applicationData.is_free">
            Free
          </div>
          <div v-else>
            <div class="unit-pricing">{{  `${getCurrencySymbol(applicationData.currency_code)} ${applicationData.single_unit_pricing}/unit` }}</div>
            <div class="monthly-pricing">{{ `${getCurrencySymbol(applicationData.currency_code)} ${applicationData.monthly_subscription_pricing}/month subscription` }}</div>
          </div>
          <div>{{ applicationData.info }}</div>
          <div><b>Area:</b> {{ applicationData.area }}</div>

          <div id="plan-info-page-container">
            <div v-if="applicationData.is_free" id="free-plan">
              <h5>Free</h5>
              <P>Unlimited access to the app, use as many as needed.</P>
            </div>
            <div v-else id="payed-plan">
              <div v-if="applicationData.single_unit_pricing" id="unit-plan-page-container" @click="paymentPlan = 'unit'">
                <input type="radio" v-model="paymentPlan" name="payment-plan" value="unit" />
                <div>
                  <div class="price-header">
                    <h5>Pay By Unit</h5>
                    {{  `${getCurrencySymbol(applicationData.currency_code)} ${applicationData.single_unit_pricing}` }}
                  </div>
                  <small>Select Quantity</small>
                  <div class="custom-quantity-input">
                    <button @click="customQuantityChooser('decrement')">-</button>
                    <span class="custom-quantity-input-number">{{ paymentInputObject.numberOfUnits }}</span>
                    <button @click="customQuantityChooser('increment')">+</button>
                  </div>
                </div>
              </div>
              <div v-if="applicationData.monthly_subscription_pricing" id="monthly-plan-page-container" @click="paymentPlan = 'monthly'">
                <input type="radio" v-model="paymentPlan" name="payment-plan" value="monthly" />
                <div>
                  <div class="price-header">
                    <h5>Subscribe Monthly</h5>
                    {{ `${getCurrencySymbol(applicationData.currency_code)} ${applicationData.monthly_subscription_pricing}/mo` }}
                  </div>
                  <P>Unlimited access to the app, use as many as needed.</P>
                </div>
              </div>
            </div>
            <button class="black-button-pill-global" @click="openModal('purchase-modal')">Checkout</button>
          </div>
          
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import instance from '../axios.js';
  export default {
    data() {
      return {
        reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
        applicationID: null,
        applicationData: null,
        questionData: null,
        categorizationsData: null,
        userData: null,
        paymentPlan: 'monthly',/* monthly or unit or free */
        paymentMethod: 'credit',
        expirationYears: Array.from(
          { length: 25 },
          (_, i) => new Date().getFullYear() + i
        ),
        paymentInputObject: {
          numberOfUnits: 0
        },
      }
    },
    async created() {
      try {
        this.applicationID = this.$route.params.applicationID;
        let applicationResponse = await instance.get(`/api/appAdmin/application/${this.applicationID}`);
        this.applicationData = applicationResponse.data;
        let questionsResponse = await instance.get(`/api/question-admin/application/${this.applicationID}`)
        let categorizations = await instance.get(`/api/appAdmin/categorization/${this.applicationID}`);
        this.questionData = [...questionsResponse.data];
        this.categorizationsData = {...categorizations.data};
        let userResponse = await instance.get(`/api/user/${applicationResponse.data.owner_uuid}`);
        this.userData = userResponse.data;
      } catch (e) {
        console.error(e);
      }
    },
    computed: {
      totalPrice() {
        return this.applicationData.single_unit_pricing * this.paymentInputObject.numberOfUnits
      }
    },
    methods: {
      formatTimestamp(timestamp) {
        const date = new Date(timestamp);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
      },
      openModal(id) {
        document.getElementById(id).showModal();
      },
      closeModal(id) {
        document.getElementById(id).close();
      },
      goToActivities() {
        this.$router.push(`/activities`);
      },
      getURLImage(file) {
        if (file != null && file != '') {
          return URL.createObjectURL(file);
        } else {
          return null;
        }
      },
      async testingPayment() {
        try {
          if (this.applicationData.is_free) {
            await instance.post('/api/user-app-purchased-junction', {
              user_id: this.$store.getters.getCurrentUser,
              application_id: this.applicationID,
              purchase_type: 'free',
              units_purchased: null,
              units_used: null,
            })
          }
          else if (this.paymentPlan == 'monthly') {
            await instance.post('/api/user-app-purchased-junction', {
              user_id: this.$store.getters.getCurrentUser,
              application_id: this.applicationID,
              purchase_type: 'monthly',
              units_purchased: null,
              units_used: null,
            })
          } else if (this.paymentPlan == 'unit') {
            if (this.paymentInputObject.numberOfUnits == '' || parseInt(this.paymentInputObject.numberOfUnits) <= 0) {
              alert('Please Insert a Unit number above 0 you would like to purchase.');
              return;
            }

            await instance.post('/api/user-app-purchased-junction', {
              user_id: this.$store.getters.getCurrentUser,
              application_id: this.applicationID,
              purchase_type: 'unit',
              units_purchased: parseInt(this.paymentInputObject.numberOfUnits),
              units_used: 0,
            })
          }
          this.closeModal('purchase-modal');
          this.openModal('receipt-modal');
        } catch (e) {
          console.error(e);
        }
      },
      formatDate(isoString) {
        const date = new Date(isoString);
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
      },
      getCurrencySymbol(currencyCode) {
        const currencyMap = {
            USD: "$",
            EUR: "€",
            GBP: "£",
            JPY: "¥",
            CNY: "¥",
            RUB: "₽"
        };
        return currencyMap[currencyCode] || "";
      },
      customQuantityChooser(operation) {
        if (operation == 'increment') {
          this.paymentInputObject.numberOfUnits++;
        } else if (operation == 'decrement') {
          if (this.paymentInputObject.numberOfUnits - 1 < 0) {
            return;
          }
          this.paymentInputObject.numberOfUnits--;
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';

  #purchase-modal {
    .purchase-modal-content {
      .layout-left {
        width: 800px;
        padding: 1rem;
      }

      .layout-right {
        width: 400px;
        padding: 1rem;
        border-radius: 10px;

        .total-price {
          display: flex;
          justify-content: space-between;
          font-size: 1.5rem;
          font-weight: 700;
          margin-top: 1rem;
        }
      }

      #free-container {
        display: flex;
      }

      #cost-container {
        display: flex;

        #payment-info-container {
          .payment-method-card {
            border-radius: 10px;
            padding: .5rem;
            border: solid 1px grey;
            display: inline-block;
            width: 120px;
            margin-right: 10px;
            font-size: .9rem;
            cursor: pointer;
            margin-bottom: 1rem;

            svg {
              height: 20px;
              margin-bottom: 5px;
            }

            &.selected-payment-method {
              border: solid 1px globalSharedVariables.$orange-1;
              background-color: globalSharedVariables.$orange-3;
            }
          }

          #payment-info {
            display: grid;
            grid-template-columns: auto auto;
            column-gap: 2rem;

            .span2Col {
              grid-column: span 2;
            }

            input {
              width: 100%;
            }
          }

          #payPal-info {
            svg {
              width: 100px;
              fill: #193F88;
              cursor: pointer;
            }
          }
        }

        #plan-info-checkout-container {
          #monthly-plan-container, #unit-plan-container {
            background-color: white;
            border-radius: 10px;
            padding: .5rem;
            margin: 5px 0;
            border: solid 1px #999999;
            cursor: pointer;
            display: grid;
            grid-template-columns: 20px 1fr;

            > div:nth-child(2) {
              flex-grow: 1;
              margin-left: 1rem;

              > div:nth-child(1) {
                font-weight: 700;
              }

              > small {
                color: grey;
              }
            }

            &:has(input[type="radio"]:checked) {
              border: solid 1px globalSharedVariables.$orange-1;
              background-color: globalSharedVariables.$orange-3;
            }
          }
        }
      }
    }
  }

  #dynamic-page-grid {
    display: grid;
    grid-template-columns: 450px 1fr;
    column-gap: 3rem;

    img {
      width: 100%;
    }

    a {
      text-decoration: none;
      color: black;
      display: block;
    }

    #application-base-info {
      background-color: #EDEDED;
      padding: 1rem;
      border-radius: 10px;
    }

    #preview-button {
      margin: 1rem 0;

      button {
        border: solid 1px black;
        border-radius: 5px;
        width: 100%;
      }
    }

    #plan-info-page-container {
      #free-plan {
        border: solid 1px globalSharedVariables.$orange-1;
        background-color: globalSharedVariables.$orange-3;
        border-radius: 10px;
        padding: 1rem;
        margin: 10px 0;
        cursor: pointer;
      }

      #payed-plan {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        column-gap: 1rem;

        #monthly-plan-page-container, #unit-plan-page-container {
          border: solid 1px #999999;
          border-radius: 10px;
          padding: 1rem;
          margin: 10px 0;
          cursor: pointer;
          display: grid;
          grid-template-columns: 20px 1fr;

          .price-header{
            display: flex;
            justify-content: space-between;
          }

          &:has(input[type="radio"]:checked) {
            border: solid 1px globalSharedVariables.$orange-1;
            background-color: globalSharedVariables.$orange-3;
          }
        }
      }
    }
  }

  .custom-quantity-input {
    $change-button-width: 50px;
    display: grid;
    grid-template-columns: $change-button-width 50px $change-button-width;

    button {
      width: $change-button-width;
      height: 30px;
      border: none;
      background-color: #E6E6E6;
      cursor: pointer;
      border-radius: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: none;
      font-size: 1.5rem;
    }

    button:nth-child(1) {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    button:nth-child(3) {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }

    .custom-quantity-input-number {
      min-width: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #E6E6E6;
    }
  }
</style>
